import {EntityFactory, Reducer} from '@modifi/redux'
import {getAuthenticatedThemisClient, InputFieldView} from '@modifi/onboarding-api-clients'

type State = Record<string, any>
const client = getAuthenticatedThemisClient()

const {actions, reducer, selectors} = EntityFactory({
  actionNamePrefix: `data/input-fields`,
  rootSelector: state => state.data.inputFields,
  fetchRequest: (): Promise<InputFieldView[]> =>
    client.InputFields.fetch()
      .then(res => res.data()?.fields)
      .then(inputFields => {
        if (!inputFields) {
          throw new Error(`InputFields endpoint returned no fields property`)
        }
        return inputFields
      }),
})

export default reducer as Reducer

export const selectInputFields = (state: State): InputFieldView[] =>
  (selectors.selectEntity(state) || []) as unknown as InputFieldView[]

export const selectInputFieldsAreLoading = selectors.selectIsLoading

export const aFetchInputFields = (): any => actions?.fetch()
